module.exports = "<p>\r\n  activity-main works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/activity/views/activity-main.component.html
// module id = ../../../../../src/app/core-modules/activity/views/activity-main.component.html
// module chunks = main